export const Types = {
  TODO_ADD: "TODO_ADD",
  TODO_COMPLETE: "TODO_COMPLETE",
  TODO_DELETE: "TODO_DELETE",
  TODO_UPDATE: "TODO_UPDATE",
  TODO_ENABLE_EDIT: "TODO_ENABLE_EDIT",
  TODO_DISABLE_EDIT: "TODO_DISABLE_EDIT",
  TODO_DISABLE_EDIT_ALL: "TODO_DISABLE_EDIT_ALL",
  ADD_TODO_ENABLE_EDIT: "ADD_TODO_ENABLE_EDIT",
  ADD_TODO_DISABLE_EDIT: "ADD_TODO_DISABLE_EDIT",
  ADD_PROJECT: "ADD_PROJECT",
  OPEN_PROJECT_FORM: "OPEN_PROJECT_FORM",
  CLOSE_PROJECT_FORM: "CLOSE_PROJECT_FORM",
  // FORM: used for controlling singular todo form open in edit mode
  FORM: {
    ADD_TODO: "ADD_TODO",
    TODO: "TODO"
  }
};

export const Modes = {
  READ: "READ",
  EDIT: "EDIT"
};
